/* AOAM demo video library player (sections/aoam-demo-videos.liquid), 2026-10-05.
   The page ships thumbnails only. Tapping one opens a single youtube-nocookie player in a lightbox
   appended to <body> (so it sits above the sticky header). Ctrl/cmd/middle click and no-JS fall
   through to the plain YouTube link on the thumbnail. Esc, the X or a click on the dark backdrop
   closes it and removes the iframe, so nothing keeps playing. */
(function () {
  if (window.__aoamDemoVideos) return;
  window.__aoamDemoVideos = true;
  var lastFocus = null;
  var X = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>';

  function close() {
    var o = document.querySelector('.dvLB');
    if (!o) return;
    o.parentNode.removeChild(o);
    document.documentElement.classList.remove('dv-lock');
    document.removeEventListener('keydown', onKey);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function onKey(e) { if (e.key === 'Escape') close(); }

  function open(a) {
    var id = a.getAttribute('data-yt') || '';
    if (!/^[\w-]{11}$/.test(id)) return false;
    var start = parseInt(a.getAttribute('data-start'), 10) || 0;
    var card = a.closest('.dvcard');
    var ttl = card && card.querySelector('.dvttl');
    var meta = card && card.querySelector('.dvmeta');
    var shop = card && card.querySelector('.dvshop');
    var title = ttl ? ttl.textContent.replace(/\s+/g, ' ').trim() : 'Video';
    close();
    lastFocus = a;

    var o = document.createElement('div');
    o.className = 'dvLB';
    o.setAttribute('role', 'dialog');
    o.setAttribute('aria-modal', 'true');
    o.setAttribute('aria-label', title);
    o.innerHTML = '<div class="dvin"><div class="dvfr"><iframe allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen></iframe></div>' +
      '<div class="dvlbmeta"><div><h3 class="dvttl"></h3><div class="dvm2"></div></div></div></div>' +
      '<button type="button" class="dvx" aria-label="Close video">' + X + '</button>';
    var f = o.querySelector('iframe');
    f.title = title;
    f.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&playsinline=1' + (start ? '&start=' + start : '');
    o.querySelector('.dvttl').textContent = title;
    if (meta) o.querySelector('.dvm2').innerHTML = meta.innerHTML;
    if (shop) {
      var s = shop.cloneNode(true);
      s.className = 'dvlbshop';
      o.querySelector('.dvlbmeta').appendChild(s);
    }
    o.addEventListener('click', function (e) { if (e.target === o) close(); });
    o.querySelector('.dvx').addEventListener('click', close);
    document.body.appendChild(o);
    document.documentElement.classList.add('dv-lock');
    document.addEventListener('keydown', onKey);
    o.querySelector('.dvx').focus({ preventScroll: true });
    try { if (typeof window.gtag === 'function') window.gtag('event', 'demo_video_play', { video_id: id, video_title: title, page_path: location.pathname }); } catch (err) {}
    return true;
  }

  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('[data-dv-root] .dvthumb') : null;
    if (!a) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    if (open(a)) e.preventDefault();
  });
})();
